// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0dd9c7bc","732":"ac0fa3f2","977":"932b8315"}[chunkId] + ".chunk.js";
};